import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../../config";

// Create Context
const GlobalDataContext = createContext();

export const GlobalDataProvider = ({ children }) => {
  const [sectionsData, setSectionsData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/layout/page/home`) 
      .then((response) => {
        const sectionsArray = response?.data?.sections || [];
        const formattedData = {};
        sectionsArray.forEach((section) => {
          formattedData[section?.section_name?.trim()] = section;
        });

        setSectionsData(formattedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching global data:", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  return (
    <GlobalDataContext.Provider value={{ sectionsData, loading, error }}>
      {children}
    </GlobalDataContext.Provider>
  );
};

export const useGlobalData = () => useContext(GlobalDataContext);
